'use client';

import { useTranslation } from '@/app/_shared/hooks/useTranslation';
import {
	type NavigationTab,
	NavigationTabs,
} from '@/components/NavigationTabs';

export const DiscoverTabs = () => {
	const { t } = useTranslation('common');

	const TabList: NavigationTab[] = [
		{ id: 'trending', label: t('common:trending'), link: '/discover/trending' },
		{ id: 'new', label: t('common:newLabel'), link: '/discover/new' },
		{ id: 'rising', label: t('common:rising'), link: '/discover/rising' },
		{
			id: 'most_view',
			label: t('common:mostView'),
			link: '/discover/most_view',
		},
	] as const;
	return <NavigationTabs tabs={TabList} className="mb-1" />;
};
